import { useQuery } from '@tanstack/react-query';
import { ApiConfig } from '@/config/api.config';
import { useAxiosAuth } from '@/hooks/useAxiosAuth';
import type { PlatformSettingsDto } from '../types/platform-settings.types';

export const usePlatformSettingsApi = () => {
    const axiosInstance = useAxiosAuth();

    return useQuery<PlatformSettingsDto>({
        queryKey: [ApiConfig.queries.superAdmin.platformSettings.queryKeys.get],
        queryFn: async () => {
            const response = await axiosInstance.get<PlatformSettingsDto>(
                ApiConfig.queries.superAdmin.platformSettings.endpoints.get,
            );
            return response.data;
        },
    });
};
